// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2YQ8Q","header":"MergedInvoice_header__1apWG"};